var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPig = function SvgPig(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3353_47313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.16699V9.17533",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.5V5.66917C14.3646 6.26594 15.1498 7.21037 15.5483 8.33333H16.6658C16.8868 8.33333 17.0987 8.42113 17.255 8.57741C17.4113 8.73369 17.4991 8.94565 17.4991 9.16667V10.8333C17.4991 11.0543 17.4113 11.2663 17.255 11.4226C17.0987 11.5789 16.8868 11.6667 16.6658 11.6667H15.5474C15.2671 12.4587 14.7919 13.1674 14.1658 13.7275V15.4167C14.1658 15.7482 14.0341 16.0661 13.7996 16.3006C13.5652 16.535 13.2473 16.6667 12.9158 16.6667C12.5842 16.6667 12.2663 16.535 12.0319 16.3006C11.7975 16.0661 11.6658 15.7482 11.6658 15.4167V14.9308C11.3904 14.977 11.1116 15.0001 10.8324 15H7.4991C7.21988 15.0001 6.94114 14.977 6.66576 14.9308V15.4167C6.66576 15.7482 6.53407 16.0661 6.29965 16.3006C6.06523 16.535 5.74729 16.6667 5.41576 16.6667C5.08424 16.6667 4.7663 16.535 4.53188 16.3006C4.29746 16.0661 4.16576 15.7482 4.16576 15.4167V13.75V13.7275C3.41073 13.0525 2.87849 12.1641 2.6395 11.1799C2.4005 10.1957 2.46602 9.16215 2.82738 8.21602C3.18874 7.26989 3.8289 6.45581 4.66313 5.88153C5.49735 5.30724 6.48631 4.99984 7.4991 5H9.58243L13.3324 2.5H13.3333Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3353_47313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pig.000854e82c7ec1038324e334dea86d47.svg";